import {
  withIndex3s8q7w1g0hyfn as withIndex,
  toList383f556t1dixk as toList,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  plus310ted5e4i90h as plus,
  toSet2orjxp16sotqu as toSet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  Companion_getInstance2gbof873kqjb4 as Companion_getInstance,
  Concretecheft49ifgmy as Concrete,
} from './VirtualType.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { default1jaun537xukbl as default_0 } from './Defaults.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Uuid1zxgztb7abqxx as Uuid } from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { Instant2s2zyzgfc4947 as Instant } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import { LocalDate31mqn6zavbpi8 as LocalDate } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { LocalTime22kisvxz6f9p4 as LocalTime } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  GenericPlaceholderException172k6j5tuvnpk as GenericPlaceholderException,
  StubPolymorphicDecoder_getInstance2p486kcer4bub as StubPolymorphicDecoder_getInstance,
} from './SerializationRegistry.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  set2ew7jrhm4kojs as set,
  get3797f9mle0itg as get,
} from './kxSerializationFieldAccess.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { until1jbpn0z3f8lbg as until } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import { SEALED_getInstance19i1cdv1u9v1e as SEALED_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { JsonNames3i9ju5gyx18ko as JsonNames } from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/JsonAnnotations.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_serNameToProperties() {
  _init_properties_SerializableProperty_kt__xtu0z0();
  return serNameToProperties;
}
var serNameToProperties;
function isEqual($this, $receiver, other) {
  var myParams = $receiver.typeParametersSerializers_fr94fx_k$();
  var otherParams = other.typeParametersSerializers_fr94fx_k$();
  var tmp;
  if ($receiver.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === other.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() && myParams.length === otherParams.length) {
    var tmp_0;
    // Inline function 'kotlin.collections.isEmpty' call
    if (myParams.length === 0) {
      tmp_0 = true;
    } else {
      var tmp0 = withIndex(myParams);
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var tmp_1;
        if (isInterface(tmp0, Collection())) {
          tmp_1 = tmp0.isEmpty_y1axqb_k$();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$1 = true;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var index = element.component1_7eebsc_k$();
          var p1 = element.component2_7eebsb_k$();
          var p2 = otherParams[index];
          var tmp_2;
          if (isInterface(p1, GeneratedSerializer())) {
            var tmp_3;
            if (isInterface(p2, GeneratedSerializer())) {
              tmp_3 = isEqual($this, p1, p2);
            } else {
              tmp_3 = false;
            }
            tmp_2 = tmp_3;
          } else {
            tmp_2 = p1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === p2.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
          }
          if (!tmp_2) {
            tmp$ret$1 = false;
            break $l$block_0;
          }
        }
        tmp$ret$1 = true;
      }
      tmp_0 = tmp$ret$1;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
}
function SerializableProperty$Generated$_get_name_$ref_4a26wk() {
  return constructCallableReference((p0) => p0.get_name_woqyms_k$(), 1, 0, 145);
}
function SerializableProperty$Generated$_get_serializer_$ref_ersuod() {
  return constructCallableReference((p0) => p0.get_serializer_u29zhh_k$(), 1, 0, 146);
}
function SerializableProperty$Generated$_get_annotations_$ref_fnh0lz() {
  return constructCallableReference((p0) => p0.get_annotations_20dirp_k$(), 1, 0, 147);
}
function SerializableProperty$Generated$_get_serializableAnnotations_$ref_4aixsa() {
  return constructCallableReference((p0) => p0.get_serializableAnnotations_8l2ro_k$(), 1, 0, 148);
}
var GeneratedClass;
function Generated() {
  if (GeneratedClass === VOID) {
    class $ {
      constructor(parent, index) {
        this.parent_1 = parent;
        this.index_1 = index;
        var tmp = this;
        tmp.name$delegate_1 = lazy(() => this.parent_1.get_descriptor_wjt6a0_k$().getElementName_u4sqmf_k$(this.index_1));
        var tmp_0 = this;
        tmp_0.serializer$delegate_1 = lazy(() => {
          var tmp = this.parent_1.childSerializers_5ghqw5_k$()[this.index_1];
          return isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.annotations$delegate_1 = lazy(() => plus(this.parent_1.get_descriptor_wjt6a0_k$().getElementAnnotations_omrjs6_k$(this.index_1), this.get_serializer_u29zhh_k$().get_descriptor_wjt6a0_k$().get_annotations_20dirp_k$()));
        var tmp_2 = this;
        tmp_2.serializableAnnotations$delegate_1 = lazy(() => {
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0 = this.get_annotations_20dirp_k$();
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var tmp0_safe_receiver = Companion_getInstance().parseOrNull_evcrzc_k$(element);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.add_utx5q5_k$(tmp0_safe_receiver);
            }
          }
          return destination;
        });
        var tmp_3 = this;
        tmp_3.defaultInfo$delegate_1 = lazy(() => {
          var tmp;
          if (!this.parent_1.get_descriptor_wjt6a0_k$().isElementOptional_heqq56_k$(this.index_1)) {
            tmp = to(null, null);
          } else {
            var tmp_0;
            try {
              var tmp_1 = this.parent_1;
              var instance1 = default_0(isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE());
              var tmp_2 = this.parent_1;
              var instance2 = default_0(isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE());
              var value1 = this.get_g4cbzo_k$(instance1);
              var value2 = this.get_g4cbzo_k$(instance2);
              var tmp_3;
              if (!equals(value1, value2)) {
                var tmp_4;
                var tmp_5;
                if (value1 instanceof Uuid()) {
                  tmp_5 = value2 instanceof Uuid();
                } else {
                  tmp_5 = false;
                }
                if (tmp_5) {
                  tmp_4 = to(null, 'Uuid.random()');
                } else {
                  var tmp_6;
                  if (value1 instanceof Instant()) {
                    tmp_6 = value2 instanceof Instant();
                  } else {
                    tmp_6 = false;
                  }
                  if (tmp_6) {
                    tmp_4 = to(null, 'Clock.System.now()');
                  } else {
                    var tmp_7;
                    if (value1 instanceof LocalDate()) {
                      tmp_7 = value2 instanceof LocalDate();
                    } else {
                      tmp_7 = false;
                    }
                    if (tmp_7) {
                      tmp_4 = to(null, 'Clock.System.nowLocal().date');
                    } else {
                      var tmp_8;
                      if (value1 instanceof LocalTime()) {
                        tmp_8 = value2 instanceof LocalTime();
                      } else {
                        tmp_8 = false;
                      }
                      if (tmp_8) {
                        tmp_4 = to(null, 'Clock.System.nowLocal().time');
                      } else {
                        tmp_4 = to(null, null);
                      }
                    }
                  }
                }
                tmp_3 = tmp_4;
              } else {
                tmp_3 = to(value1, null);
              }
              tmp_0 = tmp_3;
            } catch ($p) {
              var tmp_9;
              if ($p instanceof GenericPlaceholderException()) {
                var e = $p;
                tmp_9 = to(null, null);
              } else {
                throw $p;
              }
              tmp_0 = tmp_9;
            }
            tmp = tmp_0;
          }
          return tmp;
        });
      }
      get_name_woqyms_k$() {
        var tmp0 = this.name$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, SerializableProperty$Generated$_get_name_$ref_4a26wk(), null);
        return tmp0.get_value_j01efc_k$();
      }
      get_serializer_u29zhh_k$() {
        var tmp0 = this.serializer$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, SerializableProperty$Generated$_get_serializer_$ref_ersuod(), null);
        return tmp0.get_value_j01efc_k$();
      }
      setCopy_8a6bik_k$(receiver, value) {
        return set(this.parent_1, receiver, this.index_1, this.get_serializer_u29zhh_k$(), value);
      }
      get_g4cbzo_k$(receiver) {
        var tmp = this.parent_1;
        return get(isInterface(tmp, KSerializer()) ? tmp : THROW_CCE(), receiver, this.index_1, this.get_serializer_u29zhh_k$());
      }
      get_annotations_20dirp_k$() {
        var tmp0 = this.annotations$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, SerializableProperty$Generated$_get_annotations_$ref_fnh0lz(), null);
        return tmp0.get_value_j01efc_k$();
      }
      get_serializableAnnotations_8l2ro_k$() {
        var tmp0 = this.serializableAnnotations$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializableAnnotations', 1, tmp, SerializableProperty$Generated$_get_serializableAnnotations_$ref_4aixsa(), null);
        return tmp0.get_value_j01efc_k$();
      }
      toString() {
        return this.parent_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + '.' + this.get_name_woqyms_k$();
      }
      hashCode() {
        return getStringHashCode(this.parent_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$()) + this.index_1 | 0;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof Generated()) {
          tmp_0 = isEqual(this, other.parent_1, this.parent_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = other.index_1 === this.index_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'Generated', VOID, VOID, [SerializableProperty()]);
    GeneratedClass = $;
  }
  return GeneratedClass;
}
function get_annotations() {
  // Inline function 'kotlin.collections.listOf' call
  return emptyList();
}
function get_serializableAnnotations() {
  var tmp0 = this.get_annotations_20dirp_k$();
  var tmp2_mapNotNull_this = Companion_getInstance();
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp0_safe_receiver = tmp2_mapNotNull_this.parseOrNull_evcrzc_k$(element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.add_utx5q5_k$(tmp0_safe_receiver);
    }
  }
  return destination;
}
var SerializablePropertyClass;
function SerializableProperty() {
  if (SerializablePropertyClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SerializableProperty');
    SerializablePropertyClass = $;
  }
  return SerializablePropertyClass;
}
function get_serializableProperties(_this__u8e3s4) {
  _init_properties_SerializableProperty_kt__xtu0z0();
  if (_this__u8e3s4 instanceof Concrete()) {
    var tmp = _this__u8e3s4.get_serializableProperties_zfjiw5_k$();
    return isArray(tmp) ? tmp : THROW_CCE();
  }
  var tmp_0;
  if (!isInterface(_this__u8e3s4, GeneratedSerializer())) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.isEmpty' call
    if (_this__u8e3s4.typeParametersSerializers_fr94fx_k$().length === 0) {
      var tmp0 = get_serNameToProperties();
      // Inline function 'kotlin.collections.getOrPut' call
      var key = _this__u8e3s4.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
      var value = tmp0.get_wei43m_k$(key);
      var tmp_1;
      if (value == null) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = until(0, _this__u8e3s4.get_descriptor_wjt6a0_k$().get_elementsCount_288r0x_k$());
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var inductionVariable = this_0.first_1;
        var last = this_0.last_1;
        if (inductionVariable <= last)
          do {
            var item = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var index = item;
            var tmp$ret$5 = new (Generated())(isInterface(_this__u8e3s4, GeneratedSerializer()) ? _this__u8e3s4 : THROW_CCE(), index);
            destination.add_utx5q5_k$(tmp$ret$5);
          }
           while (!(item === last));
        // Inline function 'kotlin.collections.toTypedArray' call
        var answer = copyToArray(destination);
        tmp0.put_4fpzoq_k$(key, answer);
        tmp_1 = answer;
      } else {
        tmp_1 = value;
      }
      var tmp_2 = tmp_1;
      tmp_0 = isArray(tmp_2) ? tmp_2 : THROW_CCE();
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_1 = until(0, _this__u8e3s4.get_descriptor_wjt6a0_k$().get_elementsCount_288r0x_k$());
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
      var inductionVariable_0 = this_1.first_1;
      var last_0 = this_1.last_1;
      if (inductionVariable_0 <= last_0)
        do {
          var item_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var index_0 = item_0;
          var tmp$ret$9 = new (Generated())(isInterface(_this__u8e3s4, GeneratedSerializer()) ? _this__u8e3s4 : THROW_CCE(), index_0);
          destination_0.add_utx5q5_k$(tmp$ret$9);
        }
         while (!(item_0 === last_0));
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(destination_0);
    }
  }
  return tmp_0;
}
var SealedSerializableOptionClass;
function SealedSerializableOption() {
  if (SealedSerializableOptionClass === VOID) {
    class $ {
      constructor(index, name, secondaryNames, serializer) {
        var tmp;
        if (secondaryNames === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = secondaryNames;
        }
        secondaryNames = tmp;
        this.index_1 = index;
        this.name_1 = name;
        this.secondaryNames_1 = secondaryNames;
        this.serializer_1 = serializer;
      }
      toString() {
        return 'SealedSerializableOption(index=' + this.index_1 + ', name=' + this.name_1 + ', secondaryNames=' + toString(this.secondaryNames_1) + ', serializer=' + toString(this.serializer_1) + ')';
      }
      hashCode() {
        var result = this.index_1;
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + hashCode(this.secondaryNames_1) | 0;
        result = imul(result, 31) + hashCode(this.serializer_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SealedSerializableOption()))
          return false;
        if (!(this.index_1 === other.index_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!equals(this.secondaryNames_1, other.secondaryNames_1))
          return false;
        if (!equals(this.serializer_1, other.serializer_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SealedSerializableOption');
    SealedSerializableOptionClass = $;
  }
  return SealedSerializableOptionClass;
}
function get_serializableOptions(_this__u8e3s4) {
  _init_properties_SerializableProperty_kt__xtu0z0();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof AbstractPolymorphicSerializer() ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var poly = tmp;
  if (!equals(_this__u8e3s4.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), SEALED_getInstance()))
    return null;
  var subDesc = _this__u8e3s4.get_descriptor_wjt6a0_k$().getElementDescriptor_ncda77_k$(1);
  var tmp_0 = 0;
  var tmp_1 = subDesc.get_elementsCount_288r0x_k$();
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = Array(tmp_1);
  while (tmp_0 < tmp_1) {
    var tmp_3 = tmp_0;
    var name = subDesc.getElementName_u4sqmf_k$(tmp_3);
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = subDesc.getElementAnnotations_omrjs6_k$(tmp_3);
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element instanceof JsonNames()) {
        destination.add_utx5q5_k$(element);
      }
    }
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
      var list = toList(element_0.names_1);
      addAll(destination_0, list);
    }
    var secondaryNames = toSet(destination_0);
    var tmp_4 = poly.findPolymorphicSerializerOrNull_o3cszk_k$(StubPolymorphicDecoder_getInstance(), name);
    var tmp0_elvis_lhs_0 = (!(tmp_4 == null) ? isInterface(tmp_4, KSerializer()) : false) ? tmp_4 : null;
    var tmp_5;
    if (tmp0_elvis_lhs_0 == null) {
      return null;
    } else {
      tmp_5 = tmp0_elvis_lhs_0;
    }
    var ser = tmp_5;
    tmp_2[tmp_3] = new (SealedSerializableOption())(tmp_3, name, secondaryNames, ser);
    tmp_0 = tmp_0 + 1 | 0;
  }
  return tmp_2;
}
var properties_initialized_SerializableProperty_kt_5bf7pm;
function _init_properties_SerializableProperty_kt__xtu0z0() {
  if (!properties_initialized_SerializableProperty_kt_5bf7pm) {
    properties_initialized_SerializableProperty_kt_5bf7pm = true;
    serNameToProperties = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
  }
}
//region block: exports
export {
  SealedSerializableOption as SealedSerializableOptionlt11v40irrdi,
  Generated as Generated98d4nnzxvbxu,
  SerializableProperty as SerializableProperty3cbm268cpjr8q,
  get_serializableOptions as get_serializableOptions2omofumtgto14,
  get_serializableProperties as get_serializableProperties1162nosnaangd,
};
//endregion

//# sourceMappingURL=SerializableProperty.mjs.map
